import { render, staticRenderFns } from "./StopWordsConfigurations.vue?vue&type=template&id=55aa3712"
import script from "./StopWordsConfigurations.vue?vue&type=script&lang=js"
export * from "./StopWordsConfigurations.vue?vue&type=script&lang=js"
import style0 from "./StopWordsConfigurations.vue?vue&type=style&index=0&id=55aa3712&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports